import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appRemoverMultiplosEspacos]'
})
export class RemoverMultiplosEspacosDirective {
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event']) onKeyPress(): void {
    const inputValue = this.el.nativeElement.value;
    const cleanedValue = inputValue.replace(/\s+/g, ' ');
    if (!cleanedValue.trim()) {
      this.el.nativeElement.value = '';
    } else {
      this.el.nativeElement.value = cleanedValue;
    }
  }

  @HostListener('blur', ['$event']) onBlur(): void {
    const inputValue = this.el.nativeElement.value;
    this.el.nativeElement.value = inputValue?.trim();
  }
}
